export default {
  buttonAnterior: 'Precedente',
  buttonProximo: 'Prossimo'
}
